import { createSelector } from 'reselect';

import shipmentsSelectors from 'state/shipments/selectors';
import { getExternalProps } from 'utils/selectors';
import orderSelectors from 'state/order/selectors';

import {
  constants as dateAndTimeConstants,
  methods as dateAndTimeMethods,
  validators as dateAndTimeValidators,
} from 'utils/dateAndTimes';

import { methods as addressesMethods } from 'utils/addresses';

import { isEmpty } from 'utils/types';

const getMinAndMaxForTimes = createSelector(
  shipmentsSelectors.getShipmentTimes,
  getExternalProps.order,
  orderSelectors.getTimeWindowByShipmentKey,
  (shipmentTimes, { stopType, timeParam }, timeWindow) => ({
    minMax: dateAndTimeValidators.getRulesWithRestrictions({
      times: shipmentTimes,
      isForSuggestions: { dates: false, times: true },
      timeWindow,
    })[`${stopType}_${timeParam}`],
    date: shipmentTimes[`${stopType}_date_from`],
  })
);

const getOrderOfShipments = (state) => {
  const { mrDistribution } = state;
  const shipmentsKeysInForm = mrDistribution.data.shipments;

  const shipmentsOrder = [
    ...shipmentsKeysInForm.map((shipmentKey) => [
      shipmentKey,
      dateAndTimeConstants.STOP_TYPES.PICKUP,
    ]),
    ...shipmentsKeysInForm.map((shipmentKey) => [
      shipmentKey,
      dateAndTimeConstants.STOP_TYPES.DROPOFF,
    ]),
  ];
  return shipmentsOrder;
};

const getStop = ({ shipment, type }) => {
  const typeKey = type === 'pickup' ? 'from' : 'to';

  return {
    shipmentKey: shipment.shipmentKey,
    key: `${shipment.shipmentKey}.${type}`,
    stop_type: type,
    address: { ...shipment[`address_${typeKey}`] },
    time_from: dateAndTimeMethods.joinTimeAndDate(
      shipment[`${type}_time_from`],
      shipment[`${type}_date_from`],
      addressesMethods.getTimezoneOfAddress(
        shipment[addressesMethods.getAddressFromStopKey(type)]
      )
    ),
    time_to: dateAndTimeMethods.joinTimeAndDate(
      shipment[`${type}_time_to`],
      shipment[`${type}_date_to`],
      addressesMethods.getTimezoneOfAddress(
        shipment[addressesMethods.getAddressFromStopKey(type)]
      )
    ),

    loads: [...shipment.loads],
  };
};

const getStops = ({ shipments }) => {
  if (!isEmpty(shipments)) {
    const [firstShipment] = shipments;

    return [
      {
        ...getStop({ shipment: firstShipment, type: 'pickup' }),
        loads: (shipments || []).reduce(
          (acc, shipment) => [...acc, ...shipment.loads],
          []
        ),
      },
      ...(shipments || []).map((shipment) => ({
        ...getStop({ shipment, type: 'dropoff' }),
      })),
    ];
  }

  return [];
};

const getInsuredQuantity = () => false;

export default {
  getMinAndMaxForTimes,

  getOrderOfShipments,

  getStops,

  getInsuredQuantity,
};
